import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import * as moment from 'moment';
import {MoodLogs} from '@drl/shared/models';
import {timeFormat} from '@drl/shared/utility/time-format';

@Injectable()
export class MoodLogAdapter implements IAdapter<MoodLogs> {
  adaptToModel(resp: any): MoodLogs {
    const moodLog: MoodLogs = {...resp};
    if (resp.dateTime) {
      moodLog.dateString = new Date(resp.dateTime).toLocaleDateString();

      moodLog.timeOfCreation = moment(resp.dateTime).format(timeFormat);
    }

    return moodLog;
  }
  // sonarignore:start
  adaptFromModel(data: MoodLogs): any {
    return data;
  }
  // sonarignore:end
}
